import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  id: "navigationPlaceholder",
  style: {"padding-top":"80px"}
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-7" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "container-fluid" }
const _hoisted_7 = {
  key: 0,
  class: "row"
}
const _hoisted_8 = { class: "col" }
const _hoisted_9 = {
  key: 0,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_10 = {
  key: 1,
  class: "table table-dark"
}
const _hoisted_11 = { class: "col" }
const _hoisted_12 = {
  key: 0,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_13 = {
  key: 1,
  class: "table"
}
const _hoisted_14 = { class: "text-ellipsis" }

import { computed, ref, watch, onMounted, onUnmounted } from 'vue'
    import { useId, useOrganizationUnitId } from '@common/composables'
    import { useAdminPipelineDataPreviewPage } from '@Integrations/Pipelines/pages-core'
    import AdminNavigationV2 from '@common/AdminNavigationV2.vue'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AdminPipelineDataPreviewPage',
  setup(__props) {

    document.title = "Pipeline data preview"

    const tid = useOrganizationUnitId()
    const id = useId()

    const { useCurrentUserQuery, usePipelineDataPreviewQuery } = useAdminPipelineDataPreviewPage()

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const { runPipelineDataPreviewQueryV1, modelPipelineDataPreviewQueryV1 } = usePipelineDataPreviewQuery(id)
    const preview = computed(() => modelPipelineDataPreviewQueryV1.value)

    onMounted(() => {
        runCurrentUserQueryV1()
        runPipelineDataPreviewQueryV1()
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AdminNavigationV2, { tid: _unref(tid) }, null, 8 /* PROPS */, ["tid"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b"} }, "Pipeline data preview", -1 /* CACHED */)),
          _createElementVNode("a", {
            href: `/#/admin/integrations/pipelines/details/${_unref(tid)}/${_unref(id)}`,
            type: "button",
            class: "btn btn-link btn-sm"
          }, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("i", {
              class: "fa fa-arrow-left",
              "aria-hidden": "true"
            }, null, -1 /* CACHED */),
            _createTextVNode(" Back ", -1 /* CACHED */)
          ]))], 8 /* PROPS */, _hoisted_5)
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "col-lg-5 col-sm-6 text-right" }, null, -1 /* CACHED */))
      ])
    ]),
    _cache[5] || (_cache[5] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 30px"} }, null, -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_6, [
      (preview.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("h5", null, _toDisplayString(preview.value.SourceTitle) + " (" + _toDisplayString(preview.value.SourceData?.length) + ")", 1 /* TEXT */),
              (preview.value.MissingSourceId)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, " Missing ID column: " + _toDisplayString(preview.value.SourceId), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              (preview.value.SourceData.length)
                ? (_openBlock(), _createElementBlock("table", _hoisted_10, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _cache[3] || (_cache[3] = _createElementVNode("th", null, "#", -1 /* CACHED */)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(preview.value.SourceHeaders, (h) => {
                          return (_openBlock(), _createElementBlock("th", null, [
                            _createElementVNode("span", {
                              class: _normalizeClass({'fg-color-orange': preview.value.SourceId.includes(h)})
                            }, _toDisplayString(h), 3 /* TEXT, CLASS */)
                          ]))
                        }), 256 /* UNKEYED_FRAGMENT */))
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(preview.value.SourceData, (row, i) => {
                        return (_openBlock(), _createElementBlock("tr", null, [
                          _createElementVNode("td", null, _toDisplayString(i+1), 1 /* TEXT */),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (cell) => {
                            return (_openBlock(), _createElementBlock("td", null, _toDisplayString(cell), 1 /* TEXT */))
                          }), 256 /* UNKEYED_FRAGMENT */))
                        ]))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    ])
                  ]))
                : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("h5", null, _toDisplayString(preview.value.DestTitle) + " (" + _toDisplayString(preview.value.DestData?.length) + ")", 1 /* TEXT */),
              (preview.value.MissingDestId)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, " Missing ID column: " + _toDisplayString(preview.value.DestId), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              (preview.value.DestData.length)
                ? (_openBlock(), _createElementBlock("table", _hoisted_13, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _cache[4] || (_cache[4] = _createElementVNode("th", null, "#", -1 /* CACHED */)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(preview.value.DestHeaders, (h) => {
                          return (_openBlock(), _createElementBlock("th", null, [
                            _createElementVNode("span", {
                              class: _normalizeClass({'fg-color-orange': preview.value.DestId.includes(h)})
                            }, _toDisplayString(h), 3 /* TEXT, CLASS */)
                          ]))
                        }), 256 /* UNKEYED_FRAGMENT */))
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(preview.value.DestData, (row, i) => {
                        return (_openBlock(), _createElementBlock("tr", null, [
                          _createElementVNode("td", null, _toDisplayString(i+1), 1 /* TEXT */),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (cell) => {
                            return (_openBlock(), _createElementBlock("td", null, [
                              _createElementVNode("div", _hoisted_14, _toDisplayString(cell), 1 /* TEXT */)
                            ]))
                          }), 256 /* UNKEYED_FRAGMENT */))
                        ]))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    ])
                  ]))
                : _createCommentVNode("v-if", true)
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}
}

})